import { jsxs as d, Fragment as t, jsx as e } from "react/jsx-runtime";
import { Fragment as m } from "react";
import { useBreakpoint as N, Breakpoints as p, GenericLink as l, FAIcon as u, Accordion as f, ControlIconType as b, FontSize as k } from "@nextgen-web-framework/all";
import { s as i, H as x } from "../../HelpDeskImg-24cf6505.mjs";
const y = ({ footerData: c, helpingData: a }) => {
  const g = N(), h = [p.SM, p.XS].includes(g), v = () => {
    let n;
    return h ? n = /* @__PURE__ */ e(t, { children: c == null ? void 0 : c.map((r) => {
      var o;
      return /* @__PURE__ */ d(t, { children: [
        /* @__PURE__ */ e(
          f,
          {
            id: `footer-accordion${r.subheading}`,
            title: r.heading,
            iconType: b.ARITH,
            isBorderDesign: !1,
            fontSize: k.SMALL,
            children: /* @__PURE__ */ e(t, { children: (o = r.subheading) == null ? void 0 : o.map((s) => /* @__PURE__ */ e(
              l,
              {
                href: s.url,
                target: s.target,
                className: i["footer-nav-link"],
                children: /* @__PURE__ */ e("div", { className: i["footer-nav-heading-item"], children: s.text })
              },
              s.text
            )) })
          },
          `${r.heading}`
        ),
        /* @__PURE__ */ e("div", { className: i.division })
      ] });
    }) }) : n = /* @__PURE__ */ e(t, { children: c == null ? void 0 : c.map((r) => {
      var o;
      return /* @__PURE__ */ e(m, { children: /* @__PURE__ */ d(
        "div",
        {
          className: i["footer-container"],
          "data-testid": "footer-container-test-id",
          "data-pod-name": "commerce",
          children: [
            /* @__PURE__ */ e("h6", { className: i["footer-nav-heading"], children: r.heading }),
            (o = r.subheading) == null ? void 0 : o.map((s) => /* @__PURE__ */ e(
              l,
              {
                href: s.url,
                target: s.target,
                className: i["footer-nav-link"],
                children: /* @__PURE__ */ e("div", { className: i["footer-nav-heading-item"], children: s.text })
              },
              s.text
            ))
          ]
        },
        `${r.heading}${r.subheading}`
      ) }, r == null ? void 0 : r.heading);
    }) }), n;
  };
  return /* @__PURE__ */ d(t, { children: [
    /* @__PURE__ */ e("div", { className: i.helpdesk, "data-testid": "helpdesk-test-id", "data-pod-name": "commerce", children: a == null ? void 0 : a.map((n, r) => /* @__PURE__ */ d(m, { children: [
      /* @__PURE__ */ d("div", { className: i["helpdesk-container"], "data-testid": "helpdesk-container-test-id", "data-pod-name": "commerce", children: [
        /* @__PURE__ */ e(x, { ...n }),
        (n == null ? void 0 : n.title) && /* @__PURE__ */ e("h3", { className: i.title, children: n.title }),
        /* @__PURE__ */ e("span", { className: i.description, children: n.description }),
        /* @__PURE__ */ e("div", { className: i["button-container"], children: /* @__PURE__ */ d(l, { href: n.button.url, target: n.button.target, children: [
          /* @__PURE__ */ e("span", { className: i["button-label"], children: n.button.text }),
          /* @__PURE__ */ e("span", { className: i.icon, children: /* @__PURE__ */ e(u, { iconName: "chevron-right" }) })
        ] }) })
      ] }),
      h || a.length - 1 !== r ? /* @__PURE__ */ e("div", { className: i.division }) : ""
    ] }, n.title)) }),
    /* @__PURE__ */ e("div", { className: i.footer, "data-testid": "footer-test-id", "data-pod-name": "commerce", children: v() })
  ] });
};
export {
  y as default
};
//# sourceMappingURL=FooterNavigation.js.map
